import { TReport } from '../../../definitions';

export const REPORTS_LOAD_REQUEST = 'REPORTS_LOAD_REQUEST';
export const REPORTS_LOAD_SUCCESS = 'REPORTS_LOAD_SUCCESS';
export const REPORTS_LOAD_FAILURE = 'REPORTS_LOAD_FAILURE';

export const REPORT_SET_SELECTED = 'REPORT_SET_SELECTED';

export const REPORT_LOAD_REQUEST = 'REPORT_LOAD_REQUEST';
export const REPORT_LOAD_SUCCESS = 'REPORT_LOAD_SUCCESS';
export const REPORT_LOAD_FAILURE = 'REPORT_LOAD_FAILURE';

export const REPORT_ADD_USER_REQUEST = 'REPORT_ADD_USER_REQUEST';
export const REPORT_ADD_USER_SUCCESS = 'REPORT_ADD_USER_SUCCESS';
export const REPORT_ADD_USER_FAILURE = 'REPORT_ADD_USER_FAILURE';

export const REPORT_REMOVE_USER_REQUEST = 'REPORT_REMOVE_USER_REQUEST';
export const REPORT_REMOVE_USER_SUCCESS = 'REPORT_REMOVE_USER_SUCCESS';
export const REPORT_REMOVE_USER_FAILURE = 'REPORT_REMOVE_USER_FAILURE';

export type TReportsAction = {
  type: string;
  payload?: unknown;
  error?: unknown;
};

export type TRegionsState = {
  loading: boolean;
  adding: boolean;
  removing: string[];
  success: boolean;
  error: any;
  reports: TReport[];
  report: TReport | null;
};
